import * as MyString from "./string.js";

/**
 * FormatJSON - Format JSON to more custom readable format
 * @param {data} - Input non formated JSON
 * @return {data} - Formated JSON
 **/
export function FormatJSON(data) {
  for (let index = 0; index < data.length; index++) {
    if (index != data.length - 1) {
      if (data.charAt(index) == "[" && data.charAt(index + 1) != "]") {
        data = MyString.InsertStringInToString(data, "\n", index + 1);
      }
      if (data.charAt(index) == "}" && data.charAt(index + 1) == ",") {
        data = MyString.InsertStringInToString(data, "\n", index + 1);
      }
      if (data.charAt(index) == "]" && data.charAt(index + 1) == ",") {
        data = MyString.InsertStringInToString(data, "\n", index + 1);
      }
    } /* else {
      if (data.charAt(index) == "}") {
        data = MyString.InsertStringInToString(data, "\n", index);
      }
    } */
  }

  return data;
}
